import { parseParams, initializeAttributeValues, initializeAllAttributeKeyFields, initializeAttributeKeys, addNewOptionField } from "./helpers";

const FORM_CONTAINER_ID = "#user_form"
const KEYS_CLASSNAME = ".user-attribute-keys"
const KEYS_ENDPOINT = "/user_attribute_keys.json"

$(document).on('turbolinks:load', function() {
  initializeAllAttributeKeyFields(KEYS_CLASSNAME, KEYS_ENDPOINT);
  $('.area-field').hide();
  $('.single-email-field-toggle').hide();

  $('#otp_required_for_login').change(function() {
    var isChecked = $(this).is(':checked');
    var userId = $(this).val();
    if (isChecked) {
      $('.otp-preference-radios').show(); 
    }
    else {
      $('.otp-preference-radios').hide(); 
      $('#otp-preference-email, #otp-preference-sms, #otp-preference-auth-app').prop('checked', false);
    }
    $.ajax({
      type: "PUT",
      url: "/organization/users/"+userId,
      data: {user: {otp_required_for_login: isChecked}},
      dataType: "script"
    });    
  });

  $('#otp-preference-email, #otp-preference-sms, #otp-preference-auth-app').change(function() {
    var userId = $(this).val();
    var otpPreference = $(this).data('otpPreference');
    $.ajax({
      type: "PUT",
      url: "/organization/users/"+userId,
      data: {user: {otp_preference: otpPreference}},
      dataType: "script"
    });    
  });

  $('.user-list-checkbox').change(function (){
    if ($(".user-list-checkbox:checked").length > 0){
      $(".user-bulk-actions .bulk-action-btn").prop( "disabled", false );
    } else {
      $(".user-bulk-actions .bulk-action-btn").prop( "disabled", true );
    }
  });

  $('#bulkUpdateModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget)
    var field = button.data('field') 
    var modal = $(this)
    modal.find('.role-field').hide();
    modal.find('.status-field').hide();
    modal.find('.default-search-field').hide();
    modal.find('.attribute-group-field').hide();
    modal.find('#role').prop( "disabled", true );
    modal.find('#deactivated').prop( "disabled", true );
    modal.find('#default_post_search_id').prop( "disabled", true );
    modal.find('#default_issue_search_id').prop( "disabled", true );
    modal.find('#default_channel_search_id').prop( "disabled", true );
    modal.find('#default_narrative_search_id').prop( "disabled", true );
    modal.find('#attribute_group_id').prop( "disabled", true );

    if (field == "role") {
      modal.find('#role').prop( "disabled", false );
      modal.find('.role-field').show();
    } else if (field == "account-status") {
      modal.find('#deactivated').prop( "disabled", false );
      modal.find('.status-field').show();
    } else if (field == 'default-search') {
      modal.find('#default_post_search_id').prop( "disabled", false );
      modal.find('#default_issue_search_id').prop( "disabled", false );
      modal.find('#default_channel_search_id').prop( "disabled", false );
      modal.find('#default_narrative_search_id').prop( "disabled", false );
      modal.find('.default-search-field').show();
    } else if (field == 'attribute-group') {
      modal.find('#attribute_group_id').prop('disabled', false)
      modal.find('.attribute-group-field').show();
    }

  })

  $("#user_bulk_update_form").submit(function(e) {
    var user_ids = []
    $.each($(".user-list-checkbox:checked"), function(){
      user_ids.push($(this).val());
    });
    $("#user_ids_field").val(user_ids)
    e.preventDefault();
  });

  $("#user_upload_csv").submit(function(e) {
    var user_ids = []
    $.each($(".user-list-checkbox:checked"), function(){
      user_ids.push($(this).val());
    });
    $("#user_ids_field_csv").val(user_ids)
    e.preventDefault();
  });

  $('body').on('keydown', FORM_CONTAINER_ID + ' #attributes_field .option-field input[type="text"]', function(e) {
    if (e.keyCode == 13) {
      addNewOptionField(FORM_CONTAINER_ID, "user");
    }
  });

  $('body').on('click', `${FORM_CONTAINER_ID} .add-button`, function(e) {
    e.preventDefault();
    addNewOptionField(FORM_CONTAINER_ID, "user");
    initializeAttributeKeys($(KEYS_CLASSNAME).last(), KEYS_ENDPOINT);
  });

  initializeAttributeKeys($(KEYS_CLASSNAME).last(), KEYS_ENDPOINT);

  $('body').on('select2:select', KEYS_CLASSNAME, function (e) {
    var value_select_element = $(this).parent().next().find("select");
    var value = $(this).find(':selected').val();
    console.log(value)
    initializeAttributeValues(value_select_element, value, true)
  })

  $('#user_attribute').on('change', function() {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    params.set("user_attribute", $(this).val())
    if (url.pathname == '/submission_reviews' && params.toString().includes('user%5B')) {
      params.delete(`user[${params.toString().split('user%5B')[1].split('%5D')[0]}]`)
    }

    window.location.href = window.location.href.split('?')[0] + '?' + params
  })

  $('.multiple-email-field-toggle').on('click', function () {
    $('.area-field').show();
    $('.text-field').hide();
    $('.single-email-field-toggle').show();
    $('.multiple-email-field-toggle').hide();
    $('.area-field').prop( "disabled", false );
    $('.text-field').prop( "disabled", true );
  })

  $('.single-email-field-toggle').on('click', function () {
    $('.area-field').hide();
    $('.text-field').show();
    $('.single-email-field-toggle').hide();
    $('.multiple-email-field-toggle').show();
    $('.area-field').prop( "disabled", true );
    $('.text-field').prop( "disabled", false );
  })
});
